document.addEventListener('DOMContentLoaded', initIovation);

async function initIovation() {
  let blackBox = document.getElementById('io_black_box');

  if (!blackBox) {
    return;
  }

  await import('./config');
  await import('./loader_5.8.1');
}
